import defaultImage from "../../../assets/no-widget.svg";
import issue from "../../../assets/error-illustrations/issue.svg";
import maintenance from "../../../assets/error-illustrations/maintenance.svg";
import noAccess from "../../../assets/error-illustrations/noAccess.svg";
import noInternet from "../../../assets/error-illustrations/noInternet.svg";
import noUser from "../../../assets/error-illustrations/noUser.svg";
import noImageAvailableIllustration1 from "../../../assets/noImageAvailable-illustration/illustration_1.svg";
import noImageAvailableIllustration2 from "../../../assets/noImageAvailable-illustration/illustration_2.svg";
import report from "../../../assets/report-scheduler.svg";

export default {
	defaultImage,
	issue,
	maintenance,
	noAccess,
	noInternet,
	noUser,
	noImageAvailableIllustration1,
	noImageAvailableIllustration2,
	report
};
